export const Icon = ({
  src,
  size,
  className,
}: {
  src: string;
  size?: string | number;
  className?: string;
}) => {
  const width =
    typeof size === "string"
      ? size
      : typeof size === "number"
      ? `${size}px`
      : "20px";
  return (
    <img
      aria-hidden={true}
      decoding="async"
      src={src}
      width={width}
      height={width}
      className={className || "inline align-text-bottom"}
    />
  );
};
